import { createReducer, on } from '@ngrx/store';

import {
  searchPlacesSuccessAction,
  selectArrivalPlaceAction,
  selectDeparturePlaceAction,
  resetAutocomplete,
  selectDestinationPlaceAction
} from '@shared/base-search-bar/store/actions/search-bar.actions';
import { AutocompletePlaces } from '@search-bar/entities/autocomplete-places';

export const initialState: AutocompletePlaces = {
  airports: [],
  cities: []
};

export const autocompletePlacesReducer = createReducer(
  initialState,
  on(searchPlacesSuccessAction, (state, { places }) => places),
  on(
    selectDeparturePlaceAction,
    selectArrivalPlaceAction,
    selectDestinationPlaceAction,
    resetAutocomplete,
    () => initialState
  ),
);
